import classnames from 'classnames'

type Props = {
  index: number
  size: number
  label: string
  isCurrentDayStatRow: boolean
}

export const Progress = ({
  index,
  size,
  label,
  isCurrentDayStatRow,
}: Props) => {
  const currentRowClass = classnames(
    'text-xs font-semibold text-center p-0.5 rounded-l-full',
    {
      'bg-indigo-600 text-indigo-100': isCurrentDayStatRow,
      'bg-indigo-400 text-indigo-100': !isCurrentDayStatRow && label !== '0',
      'rounded-r-full': label !== '0',
      'bg-gray-500 text-gray-100': label === '0',
    }
  )
  return (
    <div className="justify-left m-1 flex">
      <div className="w-2 items-center justify-center">{index + 1}</div>
      <div className="ml-2 w-full">
        <div style={{ width: `${8 + size}%` }} className={currentRowClass}>
          {label}
        </div>
      </div>
    </div>
  )
}
